import { createContext } from "react";
var HeaderContextMj = createContext({
    modalSearchId: "string",
    modalSearchButtonId: "string",
    modalMenuId: "string",
    modalMenuButtonId: "string",
    isSearchOpen: false,
    onOpenSearch: function () { },
    isMenuOpen: false,
    onOpenNav: function () { },
    enableSearch: false,
    enableNavigation: false,
});
export default HeaderContextMj;
